<div class="login-wrapper">
  <div class="login-container">
    <!-- Logo/Header -->
    <div class="login-header">
      <h1 class="login-title">{{ 'login.welcome' | transloco }}</h1>
      <p class="login-subtitle">{{ 'login.subtitle' | transloco }}</p>
    </div>

    <!-- Tabs -->
    <div class="tabs-container">
      <button
        (click)="setTab('ml')"
        [class.active]="activeTab === 'ml'"
        class="tab-button">
        <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
        </svg>
        <span>{{ 'login.tabMl' | transloco }}</span>
      </button>
      <button
        (click)="setTab('password')"
        [class.active]="activeTab === 'password'"
        class="tab-button">
        <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
        <span>{{ 'login.tabPassword' | transloco }}</span>
      </button>
    </div>

    <!-- Tab content -->
    <div class="tab-content" #tabContent
         [@tabResize]="{ value: activeTab, params: { startHeight: previousTabHeight } }">
      <!-- Mercado Livre Tab -->
      <div *ngIf="activeTab === 'ml'" class="ml-tab">
        <div class="ml-info">
          <svg class="ml-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          <p class="ml-description">{{ 'login.mlDescription' | transloco }}</p>
        </div>
        <button
          (click)="loginMercadoLivre()"
          class="btn btn-primary btn-ml">
          <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"></path>
          </svg>
          <span>{{ 'login.mlButton' | transloco }}</span>
        </button>
      </div>
      
      <!-- Usuário e Senha Tab -->
      <div *ngIf="activeTab === 'password'" class="password-tab">
        <form (submit)="loginWithPassword()" class="login-form">
          <div *ngIf="sellers.length === 0">
            <div class="form-group">
              <label for="username" class="form-label">
                <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
                {{ 'login.username' | transloco }}
              </label>
              <input
                id="username"
                type="text"
                class="form-input"
                [(ngModel)]="email"
                name="username"
                [placeholder]="'login.usernamePlaceholder' | transloco"
                [disabled]="sellers.length > 0"
                required />
            </div>
        
            <div class="form-group">
              <label for="password" class="form-label">
                <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
                {{ 'login.password' | transloco }}
              </label>
              <input
                id="password"
                type="password"
                class="form-input"
                [(ngModel)]="password"
                [placeholder]="'login.passwordPlaceholder' | transloco"
                [disabled]="sellers.length > 0"
                name="password"
                required />
            </div>
          </div>
      
          <!-- Exibir combo de seleção de vendedores se sellers.length > 0 -->
          <div *ngIf="sellers.length > 0" class="form-group">
            <label for="seller" class="form-label">
              <svg class="label-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
              {{ 'login.selectSeller' | transloco }}
            </label>
            <select 
              id="seller" 
              class="form-input form-select"
              [(ngModel)]="selectedSeller" 
              *ngIf="sellers.length > 0"
              name="seller" 
              required>
              <option *ngFor="let seller of sellers" [ngValue]="seller">{{ seller.description }}</option>
            </select>
          </div>
      
          <button type="submit" class="btn btn-primary btn-submit">
            <span>{{ 'login.enter' | transloco }}</span>
            <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"></path>
            </svg>
          </button>

          <a [routerLink]="['/forgot-password']" class="forgot-password-link">
            {{ 'login.forgotPassword' | transloco }}
          </a>
        </form>
      </div>
    </div>

    <!-- Rodapé: seletor de idioma (bandeiras) -->
    <div class="login-lang-footer">
      <app-language-switcher variant="flags"></app-language-switcher>
    </div>
  </div>
  <ngx-spinner [size]="'medium'" type="ball-grid-pulse"></ngx-spinner>
</div>
